import React from "react";
import QuestionsHero from "../../img/Questions hero.svg";
import Background from "../../img/QuestionsHeroBackground.svg";
import Grid from "../../img/Bootcamp js grid.svg";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import useTranslation from "../../hooks/useTranslation";
import { useLocation } from "react-router-dom";

const useStyles = (theme, isMobile) => ({
  hero: {
    width: "100%",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    color: "#ffffff",
    borderRadius: { xs: "0 0 70px 70px", xl: "0px 0px 100px 100px" },
    background: `url(${Background})`,
    backgroundSize: "cover",
    textAlign: "center",
    padding: "0 0 100px",
  },
  typography: {
    title: {
      fontFamily: theme.typography.montserrat.bold,
      fontSize: { xs: "35px", md: "65px", xl: "75px" },
      width: { xs: "270px", md: "350px", xl: "450px" },
      marginTop: { xs: "83px", md: "0" },
      textAlign: isMobile ? "center" : "left",
    },
    info: {
      fontFamily: theme.typography.montserrat.regular,
      width: { xs: "270px", md: "600px", xl: "800px" },
      marginTop: { xs: "36px" },
      textAlign: isMobile ? "center" : "left",
    },
  },
});

const HeroSection = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const component = "HeroSection";
  const path = useLocation().pathname;
  const { title, info } = useTranslation(path, component);

  return (
    <Box sx={classes.hero}>
      <Box>
        <Typography sx={classes.typography.title}>{title}</Typography>
        <Typography sx={classes.typography.info}>{info}</Typography>
      </Box>
      {isMobile ? (
        <></>
      ) : (
        <img
          src={QuestionsHero}
          alt=""
          style={{ marginTop: "5%", width: "25%" }}
        />
      )}
      <img
        src={Grid}
        alt=""
        style={{
          position: "absolute",
          right: isMobile ? 0 : "90%",
          top: isMobile ? "30%" : "50%",
          height: isMobile ? "213px" : "433px",
        }}
      />
    </Box>
  );
};

export default HeroSection;
